import { Outlet } from 'react-router-dom'

const Catches = () => {
  return <Outlet />
}

export default Catches
